import * as React from 'react';
export default (function (props) {
    return React.createElement(
        'div',
        { className: props.className, onClick: props.onClick },
        props.children
    );
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/table/FilterDropdownMenuWrapper.js
// module id = 1602
// module chunks = 0